/**
 * @deprecated не используйте эту функцию напрямую, используйте RootThemeProvider
 * @internal
 */
export function addRootTheme(themeClasses: string) {
    if (typeof document === 'undefined') {
        return;
    }

    const classList = Array.from(document.body.classList);

    classList.forEach(token => {
        if (token.startsWith('dc-Theme')) {
            document.body.classList.remove(token);
        }
    });

    const classes = themeClasses.split(' ');
    document.body.classList.add(...classes);
}
